import LoginModal from '@/components/login-modal'
import { useLoginModal } from '@/hooks/use-login-modal'
import { regionAtom } from '@/store/root'
import ErrorBoundary from '@c/error-boundary'
import Footer from '@c/footer'
import Header from '@c/header'
import RegionInspect from '@c/region-inspect'
import img from '@i/global/footer_bg.png'
import { getBannerBottomBanner } from '@s/banner'
import { attachFormat } from '@u/format'
import { Image } from 'antd'
import cls from './index.module.scss'

const MainLayout = () => {
  const { visible, closeLoginModal } = useLoginModal()

  const region = useAtomValue(regionAtom)

  const { data } = useQuery({
    queryKey: ['首页', '底部横幅', region],
    queryFn: () => getBannerBottomBanner(),
    select: res => {
      if (isValidRes(res)) return res.data
    },
  })

  const url = useMemo(() => {
    if (data?.bannerPic) {
      const bannerUrl = attachFormat(data.bannerPic)?.[0]?.url
      return bannerUrl
    }
  }, [data])

  return (
    <ErrorBoundary>
      <div className={cls.main_layout}>
        <RegionInspect />
        <Header />
        <main className={cls.section}>
          <ErrorBoundary>
            <Outlet />
          </ErrorBoundary>
        </main>
        <div className="absolute bottom-0 left-0 w-full">
          <Image className="object-cover" fallback={img} height={300} preview={false} src={url} width="100%" />
        </div>
        <Footer />
        <LoginModal open={visible} onCancel={closeLoginModal} />
      </div>
    </ErrorBoundary>
  )
}

export default MainLayout
